import { createFileRoute } from "@tanstack/react-router";
import { redirect } from "@tanstack/react-router";
import { z } from "zod";
import { LoginPage } from "@/pages/login";
import { AuthUnavailableError } from "@/features/auth/authErrors";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: async ({ context }) => {
    const auth = await context.auth.initialize();
    if (auth.status === "authenticated") {
      throw redirect({ to: "/consortium" });
    }
    if (auth.status === "unavailable") {
      throw new AuthUnavailableError();
    }
  },
  component: LoginPage,
});
